import { customElement } from 'lit/decorators.js'
import { CSSResultGroup, html } from 'lit'
import { map } from 'lit/directives/map.js'
import { live } from 'lit/directives/live.js'
import { VariantFilterBaseExtended } from 'components/discovery/variant-filter/typing/shared-types.js'
import { selectedOptionLabelStyle } from 'components/discovery/variant-filter/components/variant-filter.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

@customElement('csc-variant-filter-color')
export class VariantFilterColors extends VariantFilterBaseExtended {
  static override styles: CSSResultGroup = [hostStyle, selectedOptionLabelStyle]

  override render() {
    return html`
      <cse-form-field>
        <cse-label>
          ${this.attribute.name}:
          <span class="selected-option">
            ${this.selectedOptionName}
          </span>
        </cse-label>

        <cse-group class="color-group" column-gap="05">
          ${map(this.visibleOptions, (option) => html`
            <cse-swatch
              variant="color"
              size="large"
              color="${option.css_color}"
              tooltip="${this.handleToolTipMessage(option)}"
              ?selected="${live(!!option.selected)}"
              ?out-of-stock="${this.shouldBeCrossedOut(option)}"
              @click="${() => this.handleSwatchClick(option)}"
            ></cse-swatch>
          `)}

          ${this.renderShowMoreLink()}
        </cse-group>
      </cse-form-field>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-variant-filter-color': VariantFilterColors
  }
}
